import React, { useEffect, useState } from 'react';
import { apiGet, apiPost } from '../../../API/Api_Url';
import { X, MapPin, Calendar, DollarSign, FileCheck } from 'lucide-react';
import { FaCheckCircle, FaEdit, FaEye, FaPlus, FaTrashAlt, FaUsers } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import UpdateLabourJobStatusModel from '../../Modal/UpdatelabourJobStatusModel';

function UserAllCompletedLabourJobPost({ RequirementState, setRequirementState }) {
    const navigate = useNavigate();
    const [LabourJobPost, setLabourJobPost] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetUserAllCompletedLabourJobPost = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/user/UserGetAllLabourJobRequirement?status=Completed');
            setLabourJobPost(response?.data || []);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetUserAllCompletedLabourJobPost();
    }, []);

    const getStatusColor = (status) => {
        switch (status) {
            case 'Completed':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const [SelectedReq, setSelectedReq] = useState(null);


    const [UpdatestatusModel, setUpdatestatusModel] = useState(false);

    const OpenUpdatestatusModal = (req) => {
        setUpdatestatusModel(true)
        setSelectedReq(req)
    }

    const CloseUpdatestatusModal = () => {
        setUpdatestatusModel(false)
        setSelectedReq()
    }

    const [AllApplication, setAllApplication] = useState([]);
    const [IsApplicationLoading, setIsApplicationLoading] = useState(false);

    const GetAllApplicationofJobPost = async (id) => {
        try {
            setIsApplicationLoading(true)
            const response = await apiGet(`api/user/UserGetAllApplicationofaLabourJob/${id}`);
            setAllApplication(response?.data);
            setIsApplicationLoading(false)
        } catch (error) {
            setIsApplicationLoading(false)
            console.error('Error fetching data:', error);
        } finally {
            setIsApplicationLoading(false)
        }
    };

    const [expandedJob, setExpandedJob] = useState(null);

    const toggleApplication = async (reqId) => {
        if (expandedJob === reqId) {
            setExpandedJob(null);
            setAllApplication([]);
        } else {
            await GetAllApplicationofJobPost(reqId);
            setExpandedJob(reqId);
        }
    };




    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            My All Labour Job Posts
                        </h1>
                        <p className="text-gray-600">Manage and track your Labour job posts</p>
                    </div>

                    <div className="flex items-center gap-4 mt-4 md:mt-0">
                        <button
                            onClick={() => navigate('/UserAddLabourJobPost')}
                            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 text-white bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"
                        >
                            <FaPlus className="h-4 w-4" />
                            Add Labour Job Post
                        </button>
                        <select
                            value={RequirementState}
                            onChange={(e) => setRequirementState(e.target.value)}
                            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0060B9]"
                        >
                            <option value="All">All</option>
                            <option value="pending">Pending</option>
                            <option value="InProgress">InProgress</option>
                            <option value="Completed">Completed</option>
                            <option value="Cancelled">Cancelled</option>
                        </select>
                    </div>

                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : LabourJobPost?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Labour Job Posts found.</p>
                        <p className="text-gray-400 mt-2">Create your first job post to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {LabourJobPost?.map((req) => (
                            <div
                                key={req?._id}
                                className="bg-white rounded-2xl shadow-lg p-6"
                            >
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">
                                        Labour Requirement
                                    </h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                            req?.Status
                                        )}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>
                                {req?.Skillsrequire?.length > 0 && (
                                    <p className="text-sm text-gray-600 mb-3">
                                        <span className="font-medium">Skills Required:</span>{" "}
                                        {req?.Skillsrequire.join(", ")}
                                    </p>
                                )}
                                <div className="grid grid-cols-2 gap-4 text-sm mb-4">
                                    <div className="flex items-center text-gray-700">
                                        <FaUsers className="h-4 w-4 mr-2 text-green-500" />
                                        <p>
                                            <span className="font-medium">Labours:</span>{" "}
                                            {req?.NumberOfLabours}
                                        </p>
                                    </div>
                                    <div className="flex items-center text-gray-700">
                                        <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                        <p>
                                            <span className="font-medium">Duration:</span>{" "}
                                            {req?.DurationInDays} days
                                        </p>
                                    </div>
                                    <div className="flex items-center text-gray-700">
                                        <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                        <p>
                                            <span className="font-medium">Per Day Rate:</span> ₹
                                            {req?.PerDayRate}
                                        </p>
                                    </div>
                                    <div className="flex items-center text-gray-700">
                                        <DollarSign className="h-4 w-4 mr-2 text-blue-500" />
                                        <p>
                                            <span className="font-medium">Total Budget:</span> ₹
                                            {req?.TotalBudget}
                                        </p>
                                    </div>
                                </div>
                                {req?.Notes && (
                                    <p className="text-gray-700 text-sm mb-3">
                                        <span className="font-medium">Notes:</span> {req?.Notes}
                                    </p>
                                )}
                                {req?.Location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.Location?.Address}, {req?.Location?.City},{" "}
                                            {req?.Location?.State}
                                        </p>
                                    </div>
                                )}

                                <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>
                                    <div className="flex items-center gap-2">
                                        <button
                                            onClick={() => OpenUpdatestatusModal(req)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                        >
                                            <FaEdit className="h-4 w-4" />
                                            Update Status
                                        </button>
                                        <button
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                                        >
                                            <FaEye className="h-4 w-4" /> View Details
                                        </button>
                                    </div>
                                    <button
                                        onClick={() => toggleApplication(req?._id)}
                                        className="mt-3 text-sm text-blue-600 hover:underline flex items-center gap-2"
                                        disabled={IsApplicationLoading}
                                    >
                                        {IsApplicationLoading && expandedJob === req?._id ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                <span>Loading...</span>
                                            </>
                                        ) : expandedJob === req?._id ? (
                                            "Hide Application"
                                        ) : (
                                            "Show Application"
                                        )}
                                    </button>
                                </div>
                                {expandedJob === req?._id && (
                                    <div className="mt-4 border-t pt-4 space-y-4">
                                        {isUploading ? (
                                            <p className="text-gray-500 text-center">Loading Applications...</p>
                                        ) : AllApplication?.filter(app => app?.Status === "Shortlisted")?.length === 0 ? (
                                            <p className="text-gray-500 text-center">No shortlisted applications found for this job post.</p>
                                        ) : (
                                            AllApplication?.filter(app => app?.Status === "Shortlisted")?.map((Application) => (
                                                <div
                                                    key={Application?._id}
                                                    className="bg-gradient-to-r from-white to-gray-50 border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition p-5"
                                                >
                                                    <div className="flex justify-between items-start mb-3">
                                                        <div className="flex items-center gap-2">
                                                            <h4 className="text-base font-semibold text-gray-900">
                                                                👷 {Application?.Labour?.fullName}
                                                            </h4>
                                                        </div>

                                                        <span className="px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                                                            {Application?.Status}
                                                        </span>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-700 mb-4">
                                                        <div>
                                                            <span className="font-medium">📞 Phone:</span> {Application?.Labour?.phoneNumber}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium">📧 Email:</span> {Application?.Labour?.emailAddress}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium">⭐ Experience:</span> {Application?.Labour?.experienceLevel} ({Application?.Labour?.yearsOfExperience} years)
                                                        </div>
                                                        <div>
                                                            <span className="font-medium">💰 Preferred Payment:</span> {Application?.Labour?.preferredPaymentMethod}
                                                        </div>
                                                    </div>

                                                    <div className="flex gap-4 text-sm text-blue-600 underline mb-4">
                                                        {Application?.Labour?.Aadhar && (
                                                            <a href={Application?.Labour?.Aadhar} target="_blank" rel="noopener noreferrer">View Aadhar</a>
                                                        )}
                                                        {Application?.Labour?.PAN && (
                                                            <a href={Application?.Labour?.PAN} target="_blank" rel="noopener noreferrer">View PAN</a>
                                                        )}
                                                    </div>

                                                    <div className="text-sm text-gray-500">
                                                        🕒 Applied: {new Date(Application?.createdAt).toLocaleDateString()}
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                )}

                            </div>
                        ))}
                    </div>
                )}
            </div>
            <UpdateLabourJobStatusModel
                isOpen={UpdatestatusModel}
                onClose={CloseUpdatestatusModal}
                SelectedReq={SelectedReq}
                GetUserAllPendingLabourJobPost={GetUserAllCompletedLabourJobPost}
            />

        </div>
    );
}

export default UserAllCompletedLabourJobPost;
